import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Import the CSS
import "vuetify/styles";

/**
 * Creates and configures the Vuetify 3 instance
 * Maintains the same theme colors as the Vue 2 version
 */
export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#00b144",
          secondary: "#25026a",
          dark: "#009624",
          light: "#ffffff",
          accent: "#006c58",
          info: "#2196f3",
          error: "#d50000",
          warning: "#ffb300",
        },
        fontFamily: "Karla, sans-serif",
      },
      dark: {
        colors: {
          primary: "#00c853",
          secondary: "#bdbdbd",
          light: "#5efc82",
          accent: "#8c9eff",
          error: "#d50000",
          warning: "#ffb300",
        },
        fontFamily: "Karla, sans-serif",
      },
    },
  },
  defaults: {
    global: {
      font: {
        family: "Karla, sans-serif",
      },
    },
  },
});
